import React, { useEffect, useState } from "react";
import { Card, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  getDigitalRamNameCount,
  submitDigitalRamNameApi,
} from "../RamNamBookCRUD";
import { toast } from "react-toastify";
import { t } from "i18next";

const DigitalRamTapCard = ({ onSubmit }) => {
  const { i18n } = useTranslation();
  const [todayCount, setTodayCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [animate, setAnimate] = useState(false);
  const [prevRamNam, setPrevRamNam] = useState(0);
  const [memberId, setMemberId] = useState(null);

  const getText = (en, hi, gu) => {
    if (i18n.language === "hi") return hi;
    if (i18n.language === "gu") return gu;
    return en;
  };

  // ✅ STEP 1: Get memberId from localStorage
  useEffect(() => {
    const storedCustomer = localStorage.getItem("customer");
    if (!storedCustomer) {
      toast.error("Member not found. Please login again.");
      return;
    }
    const customerObj = JSON.parse(storedCustomer);
    if (!customerObj?.ramNamBookMemberID) {
      toast.error("Invalid member data");
      return;
    }
    setMemberId(customerObj.ramNamBookMemberID);
  }, []);

  // ✅ STEP 2: Call API when memberId is available
  useEffect(() => {
    if (memberId) {
      getDigitalRamNameData(memberId);
    }
  }, [memberId]);

  const getDigitalRamNameData = async (memberId) => {
    try {
      setLoading(true);
      const res = await getDigitalRamNameCount(memberId);
      if (res.data?.isSuccess) {
        setPrevRamNam(res.data.data);
      } else {
        toast.error(res.data?.message || "Failed to load summary");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleRamTap = () => {
    setTodayCount((prev) => prev + 1);
    setAnimate(true);
    setTimeout(() => setAnimate(false), 300);
  };

  const handleSubmit = async () => {
    if (todayCount === 0) return;

    setLoading(true);
    try {
      const res = await submitDigitalRamNameApi(memberId, todayCount, 2);
      if (res.data?.isSuccess === true) {
        toast.success(res.data.message);
        setTodayCount(0);
        await getDigitalRamNameData(memberId);
      } else {
        toast.error(res.data?.message || "Something went wrong");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* ================= DESKTOP VIEW ================= */}
      <div className="d-none d-md-flex justify-content-center px-4">
        {/* <div className="d-flex justify-content-center px-3 px-md-4"> */}
        <Card
          className="border-0 rounded-4 shadow-lg w-100"
          style={{
            maxWidth: "900px",
            background: "linear-gradient(135deg,#fff7f0,#fff)",
          }}
        >
          <Card.Body className="p-4 p-md-5">
            <div className="row align-items-center">
              {/* LEFT DEVOTIONAL */}
              <div className="col-12 col-md-5 text-center mb-4 mb-md-0">
                <div
                  className="mx-auto d-flex align-items-center justify-content-center"
                  style={{
                    width: 200,
                    height: 200,
                    borderRadius: "50%",
                    background:
                      "radial-gradient(circle, rgba(255,138,0,0.35), transparent 70%)",
                  }}
                >
                  <img
                    src="/assets/logo/ram.jpg"
                    alt="Shri Ram"
                    className="rounded-circle shadow"
                    style={{
                      width: 200,
                      height: 200,
                      objectFit: "cover",
                      border: "5px solid #fff",
                    }}
                  />
                </div>

                {/* <h4 className="fw-bold mt-3 mb-1">राम नाम</h4>
              <small className="text-muted">Ram Name • રામ નામ</small> */}
              </div>

              {/* RIGHT CONTENT */}
              <div className="col-12 col-md-7 text-center">
                <p className="fw-bold text-[#FF4F00] mb-4 fs-5">
                  રામ નામ / राम नाम / RAM Name{" "}
                </p>
                {/* <small className="text-muted">Ram Name • </small> */}
                <div
                  className="rounded-4 mb-3 p-3"
                  style={{
                    background: "#fff",
                    boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                  }}
                >
                  {/* TOTAL RAM NAME */}
                  <div className="d-flex justify-content-between align-items-center mb-2 px-12">
                    <small className="text-dark fs-6">
                      {getText(
                        "Total RAM Name:",
                        "कुल राम नाम:",
                        "કુલ રામ નામ:"
                      )}
                    </small>
                    <p className="fw-bold mb-0 text-[#ff4f00] fs-6">
                      {prevRamNam}
                    </p>
                  </div>

                  {/* TODAY COUNT */}
                  <div className="d-flex justify-content-between align-items-center px-12">
                    <small className="text-dark fs-6">
                      {getText("Count:", "गणना:", "ગણતરી:")}
                    </small>
                    <p className="fw-bold mb-0 text-success fs-6">
                      {todayCount.toLocaleString()}
                    </p>
                  </div>
                </div>

                {/* RAM BUTTON */}
                <Button
                  onClick={handleRamTap}
                  className="w-100 rounded-pill d-flex align-items-center justify-content-center gap-3 mb-3"
                  style={{
                    height: 44,
                    fontSize: "1.1rem",
                    background: "linear-gradient(90deg,#ff8a00,#ff3d00)",
                    border: "none",
                    boxShadow: "0 10px 22px rgba(255,79,0,0.4)",
                  }}
                >
                  {todayCount !== 0 ? (
                    <span
                      className="bg-white rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: 38,
                        height: 38,
                        //   fontWeight: "bold",
                        color: "#000",
                        fontSize: "1.1rem",
                        transform: animate ? "scale(1.3)" : "scale(1)",
                        transition: "transform 0.2s ease",
                      }}
                    >
                      {t("ram")}
                    </span>
                  ) : (
                    ""
                  )}
                  <span className="fw-bold">{t("taptoJap")}</span>
                </Button>

                {/* SUBMIT */}
                <Button
                  disabled={loading || todayCount === 0}
                  onClick={handleSubmit}
                  className="w-100 rounded-4 py-2"
                  // variant="success"
                  style={{
                    fontSize: "1.1rem",
                    boxShadow: "0 8px 18px rgba(18, 124, 42, 0.35)",
                    backgroundColor: "#076d07ff",
                    color: "#ffff",
                  }}
                >
                  {loading
                    ? "Submitting..."
                    : getText(
                        "Submit Your Jaap",
                        "जाप सबमिट करें",
                        "જાપ સબમિટ કરો"
                      )}
                </Button>
              </div>
            </div>
          </Card.Body>
        </Card>
      </div>

      {/* ================= MOBILE VIEW ================= */}
      <div className="d-md-none">
        <Card className="border-0 rounded-4 shadow w-100">
          <Card.Body className="p-3 text-center">
            {/* IMAGE */}
            <div className="d-flex justify-content-center mb-3">
              <img
                src="/assets/logo/ram.jpg"
                alt="Shri Ram"
                className="rounded-circle shadow"
                style={{ width: 140, height: 140, objectFit: "cover" }}
              />
            </div>

            <p className="fw-bold text-[#ff4f00] mb-3">
              રામ નામ / राम नाम / RAM Name
            </p>

            {/* COUNTS */}
            <div className="bg-white rounded-3 p-3 mb-3 shadow-sm">
              <div className="d-flex justify-content-between mb-2 px-12">
                <small>
                  {getText("Total RAM Name:", "कुल राम नाम:", "કુલ રામ નામ:")}
                </small>
                <strong className="text-[#ff4f00]">{prevRamNam}</strong>
              </div>
              <div className="d-flex justify-content-between px-12">
                <small>{getText("Count:", "गणना:", "ગણતરી:")}</small>
                <strong className="text-success">
                  {todayCount.toLocaleString()}
                </strong>
              </div>
            </div>

            {/* TAP BUTTON */}
            <Button
              onClick={handleRamTap}
              className="w-100 rounded-pill d-flex align-items-center justify-content-center gap-3 mb-3"
              style={{
                height: 44,
                fontSize: "1.1rem",
                background: "linear-gradient(90deg,#ff8a00,#ff3d00)",
                border: "none",
                boxShadow: "0 10px 22px rgba(255,79,0,0.4)",
              }}
            >
              {" "}
              {todayCount !== 0 ? (
                <span
                  className="bg-white rounded-circle d-flex align-items-center justify-content-center"
                  style={{
                    width: 38,
                    height: 38,
                    //   fontWeight: "bold",
                    color: "#000",
                    fontSize: "1.0rem",
                    transform: animate ? "scale(1.3)" : "scale(1)",
                    transition: "transform 0.2s ease",
                  }}
                >
                  {t("ram")}
                </span>
              ) : (
                ""
              )}
              <p className="">{t("taptoJap")}</p>
            </Button>

            {/* SUBMIT */}
            <Button
              disabled={loading || todayCount === 0}
              onClick={handleSubmit}
              className="w-100 rounded-3"
              style={{ backgroundColor: "#076d07" }}
            >
              {loading
                ? "Submitting..."
                : getText(
                    "Submit Your Jaap",
                    "जाप सबमिट करें",
                    "જાપ સબમિટ કરો"
                  )}
            </Button>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default DigitalRamTapCard;
